var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPredict(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8184 14.9125H34.0013V32.1863H15.8184V14.9125ZM24.9094 40.3711C26.165 40.3711 27.1823 39.3538 27.1823 38.0983C27.1823 36.8428 26.165 35.8254 24.9094 35.8254C23.6539 35.8254 22.6366 36.8428 22.6366 38.0983C22.6366 39.3538 23.6539 40.3711 24.9094 40.3711Z",
    fill: "#DC0032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6383 44.0079H32.1831C34.1887 44.0079 35.8197 42.3769 35.8197 40.3713V7.63658C35.8197 5.63101 34.1887 4 32.1831 4H17.6368C15.6312 4 14.0002 5.63101 14.0002 7.63658V13.9799L14 14.0006L14.0002 14.0214V33.0772L14 33.098L14.0002 33.1187V40.3713C14.0002 42.3769 15.6312 44.0079 17.6368 44.0079H22.1825C22.6844 44.0079 23.0917 43.6015 23.0917 43.0987C23.0917 42.596 22.6844 42.1896 22.1825 42.1896H17.6368C16.634 42.1896 15.8185 41.3741 15.8185 40.3713V34.0071H34.0014V40.3713C34.0014 41.3741 33.1859 42.1896 32.1831 42.1896H27.6383C27.1356 42.1896 26.7292 42.596 26.7292 43.0987C26.7292 43.6015 27.1356 44.0079 27.6383 44.0079ZM15.8185 14.9098V32.1888H34.0014V14.9098H15.8185ZM34.0014 13.0915H15.8185V7.63658C15.8185 6.6338 16.634 5.81829 17.6368 5.81829H32.1831C33.1859 5.81829 34.0014 6.6338 34.0014 7.63658V13.0915ZM23.0914 10.3639H26.728C27.2308 10.3639 27.6372 9.95656 27.6372 9.45471C27.6372 8.95286 27.2308 8.54556 26.728 8.54556H23.0914C22.5896 8.54556 22.1823 8.95286 22.1823 9.45471C22.1823 9.95656 22.5896 10.3639 23.0914 10.3639Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8686 20.2254H26.4468V27.6404H25.7059V21.0654L22.9912 22.2973L22.7075 21.72L25.8686 20.2254Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPredict);
export default __webpack_public_path__ + "static/media/iconPredict.97b3d8f1925439e6b3e0f18e983a8c27.svg";
export { ForwardRef as ReactComponent };